import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {KitDocument, KitDocumentSearchParams} from '@accounting/_common/models/kit-document.models';

export const CheckState = createAction(
    '[KitDocuments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: KitDocument[] } }>()
);

export const CheckStateSuccess = createAction(
    '[KitDocuments] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: KitDocument[] } }>()
);

export const LoadList = createAction(
    '[KitDocuments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[KitDocuments] Load List Success',
    props<{ payload: { items: KitDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[KitDocuments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[KitDocuments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[KitDocuments] Set Filter',
    props<{ payload: KitDocumentSearchParams }>()
);

export const SetLoading = createAction(
    '[KitDocuments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[KitDocuments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[KitDocuments] Update Item Success',
    props<{ payload: KitDocument }>()
);

export const DeleteItem = createAction(
    '[KitDocuments] Delete Item',
    props<{ payload: KitDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[KitDocuments] Delete Item Success',
    props<{ payload: KitDocument }>()
);

export const DeleteItemFailure = createAction(
    '[KitDocuments] Delete Item Failure',
    props<{ payload: KitDocument }>()
);

export const SetInitialState = createAction(
    '[KitDocuments] Set Initial State'
);
